/**
 * Configuration for different metric types used in the MetricValue component.
 * Each metric type defines its maximum value for progress bar calculation,
 * display label, and formatting options.
 */

interface MetricTypeConfig {
  max: number;
  label: string;
}

export const METRIC_TYPES = {
  INSTITUTION_ANNUAL_REVENUE: {
    max: 100_000_000,
    label: 'Annual Revenue',
  },
  NR_STUDENTS_UNDER_INSTITUTION: {
    max: 10_000,
    label: 'Students'
  },
  NR_SCHOOLS: {
    max: 30,
    label: 'Nr. of Child Institutions'
  },
  EXPORT_DURATION: {
    max: 180,
    label: 'Export Duration'
  },
  NR_EXPORTED_RECORDS: {
    max: 10_000,
    label: 'Exported Records'
  },
  NR_INSTITUTIONS_UNDER_AGENCY: {
    max: 100,
    label: 'Institutions'
  },
  URL_COUNT_BY_TYPE: {
    max: 500_000,
    label: 'URL Count'
  },
  URL_AVG_CRAWL_AGE: {
    max: 180,
    label: 'Avg Crawl Age (days)'
  },
  URL_MEDIAN_NEVER_CRAWLED_AGE: {
    max: 30,
    label: 'Median Never Crawled Age (days)'
  },
  CONTACT_VERIFICATION_COUNT: {
    max: 1_000_000,
    label: 'Verification Count'
  },
  ENTITY_CREATION_COUNT: {
    max: 500_000,
    label: 'Entity Creation Count'
  },
  TITLE_POSITIONS: {
    max: 3,
    label: 'Title Positions'
  },
  TITLE_CONTACTS: {
    max: 100_000,
    label: 'Title Contacts'
  },
  ROLE_RANK: {
    max: 100,
    label: 'Rank'
  },
  ROLE_CONFIDENCE: {
    max: 100,
    label: 'Confidence'
  },
  EVENT_QUEUE_DEPTH: {
    max: 100_000,
    label: 'Queue Depth'
  },
  CONTACT_AGE_DISTRIBUTION: {
    max: 1_000_000,
    label: 'Contact Age Distribution'
  },
  DECISION_COUNT: {
    max: 1_000_000,
    label: 'Decision Count'
  },
  CANONICAL_CONTACT_EMAIL_VERIFICATION_AGE: {
    max: 5_000_000,
    label: 'Email Verification Age'
  }
} as const satisfies Record<string, MetricTypeConfig>;

export type MetricType = keyof typeof METRIC_TYPES;